<script>
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  import { clickOutside } from "$lib/utilities/dom-helpers";
  import ResponsiveColumn from "$lib/components/ResponsiveColumn.svelte";
  import Icon from "$lib/components/Icon.svelte";
  import MenuTrigger from "./MenuTrigger.svelte";
  import MenuItem from "../MenuItem.svelte";

  export let data;
  export let isOpen = false;

  let topElement =
    data.children &&
    data.children[0] &&
    (data.children[0].url || data.children[0].destination?.fields.url);

  let highlightedElement = null;

  let hasOnlyViewAllLink = data.children.length === 1 && data.children[0].type === "viewAllLink";

  function toggle(e) {
    e.preventDefault();
    isOpen = !isOpen;
  }

  $: showHighlightBg =
    highlightedElement && highlightedElement.url === topElement && highlightedElement.highlight;

  $: currentURL = $page.url?.pathname; //This variable does not populate in Storybook

  let tipBgColor = "bg-white"; // default color for little diamond on the tip of the dropdown menu

  $: if (showHighlightBg) {
    tipBgColor = "bg-indigo-50";
  } else if (hasOnlyViewAllLink) {
    tipBgColor = "bg-neutral-100";
  } else {
    tipBgColor = "bg-white";
  }

  let menuLabelId = `menu-${data.sys.id}`;
</script>

<ResponsiveColumn>
  <div
    class="px-1 relative"
    use:clickOutside={() => {
      isOpen = false;
    }}
  >
    <h3 id={menuLabelId} class="sr-only">{data.fields.trigger?.fields?.text} Menu</h3>
    <MenuTrigger {data} ariaLabel={menuLabelId} {isOpen} on:click={toggle} />

    {#if data.children && isOpen}
      <div class="lg:absolute w-full flex flex-col lg:justify-center lg:items-center top-56">
        <!-- active menu indicator: desktop only -->
        <div
          class={`hidden z-50 lg:flex h-[24px] w-[24px] border border-r-0 border-b-0 border-neutral-300 -mb-10 ${tipBgColor}`}
          style="transform: rotate(45deg);"
        >
          &nbsp;
        </div>

        <!-- dropdown menu items-->
        <ul
          class="list-none z-10 bg-indigo-50 lg:bg-white min-w-max lg:border lg:border-neutral-300 border-t -mt-2"
          aria-labelledby={menuLabelId}
        >
          {#each data.children as child}
            {@const url = child.url ?? child.destination?.fields.url}
            {@const menuItemId = `menu-item-${child.sys.id}`}
            <li aria-current={url === currentURL || `${url}/` === currentURL}>
              <MenuItem
                {url}
                haspopup
                expanded={isOpen}
                bind:highlightedElement
                isViewAllLink={child.type === "viewAllLink"}
                label={menuItemId}
              >
                <span class="self-center">{child.text}</span>
                <span class="place-self-end"><Icon type="chevron-right" /></span>
              </MenuItem>
            </li>
          {/each}
        </ul>
      </div>
    {/if}
  </div>
</ResponsiveColumn>
